import React from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import Spinner from "../../reusableComponents/spinner/Spinner";

const ConfirmationModal = ({
  open,
  handleConfirm,
  handleClose,
  message,
  loading,
}) => {
  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: 400, md: 410 },
          bgcolor: "#131313",
          boxShadow: 24,
          p: { xs: 4, md: 3 },
          borderRadius: 2,
        }}
      >
        <Typography id="modal-title" variant="h6" component="h2">
          Confirmation
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {message || "Are you sure you want to proceed?"}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
            gap: 2,
          }}
        >
          <Button variant="outlined" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ width: "max-content", color: "#000", minWidth: "100px" }}
            className="standard-button"
            onClick={handleConfirm}
          >
            {loading ? <Spinner size={25} /> : "Confirm"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
